import { render, staticRenderFns } from "./ExpireAlert.vue?vue&type=template&id=72d13ab0&scoped=true"
import script from "./ExpireAlert.vue?vue&type=script&lang=js"
export * from "./ExpireAlert.vue?vue&type=script&lang=js"
import style0 from "./ExpireAlert.vue?vue&type=style&index=0&id=72d13ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d13ab0",
  null
  
)

export default component.exports